import React from 'react'
import { Pill } from '@myxplor/ui'

const FlagPill = ({ flags }) =>
  Array.isArray(flags) ? flags.map((f, i) => showFlag(f, i)) : showFlag(flags)

const showFlag = (flag, key = 0) => (
  <Pill key={`Pill_${key}`}>
    {flag.toUpperCase()}
  </Pill>
)

export default FlagPill



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/view/flag-pill.jsx